import { render, staticRenderFns } from "./LeversBox.vue?vue&type=template&id=a9fc76bc&scoped=true"
import script from "./LeversBox.vue?vue&type=script&lang=ts"
export * from "./LeversBox.vue?vue&type=script&lang=ts"
import style0 from "./LeversBox.vue?vue&type=style&index=0&id=a9fc76bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fc76bc",
  null
  
)

export default component.exports